<template>
    <section>
        <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
            <div class="ant-col" style="padding: 20px;">
                <h6 class="font-semibold text-md mb-35" >{{ companyName }}</h6>
                <h6 class="font-semibold text-md mb-35" >{{ ownershipeType }}</h6>
                <h6 class="font-semibold text-md mb-35" >{{ mobileNo }}</h6>
                <h6 class="font-semibold text-md mb-35" >{{ email }}</h6>
                <h6 class="font-semibold text-md mb-35" >{{ telePhone }}</h6>
                <h6 class="font-semibold text-md mb-35" >{{ fax }}</h6>
                <h6 class="font-semibold text-md mb-35" >{{ address }}</h6>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from "pinia";
import { useLocaleStore } from "../../../../../stores/locale-store.js";
export default {
    name: "Informations",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed:{
         ...mapState(useLocaleStore, ['locale']),
        isLocal(){
            if (this.locale == "bn"){
                return "bn";
            }
            return "en";
        },
        companyName() {
            if (this.data){
                if (this.isLocal == "bn" && this.data.nameBn) {
                    return this.$t('form-label.company-name')  + " : " + this.data.nameBn;
                }else if (this.isLocal == "en" && this.data.nameEn) {
                    return this.$t('form-label.company-name') + " : " + this.data.nameEn;
                }
            }
            return this.$t('form-label.name') + " : ";
        },
        mobileNo(){
                if (this.data && this.data.mobileNo){
                return this.$t('form-label.alt-mobile') + " : " + this.data.mobileNo;
            }
            return this.$t('form-label.alt-mobile') + " : ";
        },
        email(){
            if (this.data && this.data.email){
                return this.$t('form-label.email') + " : " + this.data.email;
            }
            return this.$t('form-label.email') + " : ";
        },
        ownershipeType(){
            if (this.data && this.data.ownership){
                return this.$t('form-label.ownership-type') + " : " + this.data.ownership;
            }
            return this.$t('form-label.ownership-type') + " : ";
        },
        telePhone(){
            if (this.data && this.data.telNo){
                return this.$t('form-label.alt-phone') + " : " + this.data.telNo;
            }
            return this.$t('form-label.alt-phone') + " : ";
        },
        fax(){
            if (this.data && this.data.faxNo){
                return this.$t('form-label.alt-fax') + " : " + this.data.faxNo;
            }
            return this.$t('form-label.alt-fax') + " : ";
        },
        address(){
            if (this.data && this.data.address){
                return this.$t('form-label.address') + " :  " + this.data.address;
            }
            return this.$t('form-label.address') + " :  ";
        },
    }

}
</script>

<style>

</style>